module.exports = __webpack_public_path__ + "img/sapins-big.61cf45c6.png";